import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-black text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center mb-6">
              <div className="bg-gradient-to-r from-purple-600 to-purple-500 text-white w-12 h-12 rounded-full font-bold text-lg flex items-center justify-center">
                Fi
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">Quick links</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">FAQs</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Support</a></li>
              <li><a href="https://agents.beunframed.com/wp-content/uploads/2025/11/Customer-Service-Contact-Details.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">Customer Service</a></li>
              <li><a href="https://agents.beunframed.com/wp-content/uploads/2025/11/Return-policy-and-process.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">Return Policy</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">Resources</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="https://agents.beunframed.com/wp-content/uploads/2025/11/Terms-and-Conditions-for-FidelioHQ-OU.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">Terms & Conditions</a></li>
              <li><a href="https://agents.beunframed.com/wp-content/uploads/2025/11/Refund-and-Dispute-Policy.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">Refund & Dispute Policy</a></li>
              <li><a href="https://agents.beunframed.com/wp-content/uploads/2025/11/Cancellation-Policy.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">Cancellation Policy</a></li>
              <li><a href="https://agents.beunframed.com/wp-content/uploads/2025/11/Legal-and-Export-Restrictions.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">Legal Restrictions</a></li>
              <li><a href="https://agents.beunframed.com/wp-content/uploads/2025/11/Terms-and-Conditions-for-FidelioHQ-OU.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">Promotions T&C</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">Stay connected</h3>
            <div className="flex gap-4 mb-4">
              <a href="#" className="bg-gray-800 hover:bg-purple-600 w-10 h-10 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-purple-600 w-10 h-10 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-purple-600 w-10 h-10 rounded-lg flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-purple-600 w-10 h-10 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
            <a href="mailto:support@fideliohq.com" className="text-gray-400 hover:text-white transition-colors text-sm block">
              Email Us
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 Fideliohq. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
